import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  > div:last-child {\n    padding: 20px;\n    border-radius: 16px;\n    @media (max-width: 1200px) {\n      width: 50%;\n    }\n    @media (max-width: 768px) {\n      //width: 90%;\n      width: 360px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  position: relative;\n  h3 {\n    color: ",
        ";\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 16px;\n    line-height: 1.5;\n  }\n  i {\n    position: absolute;\n    right: 0;\n  }\n  a {\n    width: 100%;\n    padding: 12px;\n    line-height: 1.5;\n    font-size: 16px;\n    font-weight: 600;\n    color: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 6px;\n    display: inline-block;\n    text-align: center;\n  }\n  .body {\n    margin-bottom: 32px;\n    color: ",
        ";\n    line-height: 1.5;\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled, { useTheme } from "styled-components";
import Modal from "@/components/modal/Modal";
import Link from "next/link";
import Icon from "../icon/Icon";
import { Close, Sizes } from "@/components/icon/IconList";
export const BottomDrawer = (props)=>{
    const { text , title , position , link , linkTitle , ...rest } = props;
    const theme = useTheme();
    //채널톡 이슈로 임시 모달로 ui변경
    return /*#__PURE__*/ _jsx(CustomModal, {
        ...rest,
        children: /*#__PURE__*/ _jsxs(DrawerWrapper, {
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    onClick: props.onClose,
                    icon: Close,
                    size: Sizes.small,
                    color: theme.new.colors.sol_gray_800
                }),
                /*#__PURE__*/ _jsx("h3", {
                    children: title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "body",
                    children: text
                }),
                link && /*#__PURE__*/ _jsx(Link, {
                    target: "_blank",
                    href: link,
                    children: linkTitle || "자세히 보기"
                })
            ]
        })
    });
};
const CustomModal = styled(Modal).withConfig({
    componentId: "sc-6b18ed79-0"
})(_templateObject());
const DrawerWrapper = styled.div.withConfig({
    componentId: "sc-6b18ed79-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_800, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_gray_600);
